/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables as theme } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../../../utils/CommonStyles';

export const StyledFlexiCalendarBoxDiv = styled.div`
  ${rtl`
  &.search__flexible_calendar{
    border-top:${theme.border.borderWidth01} ${theme.border.borderStyleDefault} ${theme.color.neutral20};
    @media ${theme.mediaQuery.desktop} {
      padding-left: ${toRem(40)};
    }
    .stepper-wrapper{
      @media ${theme.mediaQuery.lg}{
      max-width:${toRem(286)};
      }
      margin-top: ${toRem(82)};
    }
    .stepper-wrapper{
      @media ${theme.mediaQuery.lg} {
       margin-top: 0;
      }
      @media ${mediaQuery.tabletOnly} {
       margin-top: 0;
      }
    }
    .m-stepper-label{
      min-width: ${toRem(118)};
    }
    
    .m-stepper{
      padding-left: ${toRem(24)};
    }
    .default-month-state {
      color: ${theme.color.neutral40};
      border-color: ${theme.color.neutral30};
      font-size: ${toRem(14)};
    }
    .default-month-state: hover{
      background-color:${theme.color.neutral20} ;
      color:${theme.color.base10} ;
      box-shadow: none;
    }
    .months-pill-container{
      padding-bottom: ${toRem(6)} !important;
      .month-pill:focus:not(:focus-visible) {
        outline: 0;
        box-shadow: none;
      }     
      .month-pill{
        min-width:${toRem(104)};
        font-weight:500;
        @media only ${theme.mediaQuery.lg}{
          min-width:${toRem(100)};
        }
        &:nth-child(3){
          @media only ${theme.mediaQuery.md}{
            margin-right:${toRem(8)} !important;
          }
        }
      }
    }
  }
`}
`;
